export const veiculoInicialState = {
    veiculo: {
        id_Veiculo: "",
        id_ClienteVeiculo: "",
        placa: "",
        chassi: "",
        categoria:"",
        n_motor: "",
        renavam: "",
        anoFab: "",
        anoMod: "",
        tipo: "",
        marca: "",
        modelo: "",
        cor: "",
        km: "",
        estado: "",
        cidade: "",

        valorFipe: "",
        codigoFipe: "",
        valorMensal: "",
        valorAdesao: "",
        whatsapp_Cotacao: "",
        situacao: "",

        id_Tipo: undefined,
        id_Plano: undefined,

        listaTipo: [],

        id_Franquia: undefined,
        id_Colaborador: undefined,

        nomeCliente: "",
        nomeFranquia: "",

        status: "",
        dataCadastro: "",

        userCadastro: "",
    },
    cotacao: {
        id_Cotacao: "",
        valorFipe: "",
        dataCotacao: "",
        valorCotacao: "",
        valorAdesao: "",
        statusCotacao: "",
        whatsapp: "",

        id_Veiculo: "",
        id_Franquia: "",
        id_Colaborador: "",

        nomeFranquia: "",
        nomeCliente: "",
        modelo: "",
        placa: "",
        anoMod: "",
        whatsapp: "",

    },
}
//-----------------------------------------------------
export const veiculoReducer = (state = veiculoInicialState, action) => {

    switch (action.type) {

        case 'set_veiculo':
            return { ...state, veiculo: action.payload };
        case 'set_cotacao':
            return { ...state, cotacao: action.payload };

        case 'set_limparVeiculo':
            return veiculoInicialState;
        
        case 'set_InicialCotacao':
            return { ...state, cotacao: veiculoInicialState.cotacao };

        default:
            return state;

    }
};
//-----------------------------------------------------
